import {useQuery} from "react-query";
import {Client, CompressorPropertyWithValue} from "../../autogenerate/api.generated.clients";

export function useAlertSetPoints(frameSerialNumber: string) {
    return useQuery<CompressorPropertyWithValue[]>("compressor-set-points", () => new Client().compressor_GetCurrentSetPointsForCompressor(frameSerialNumber), {refetchOnWindowFocus:false});
}